(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["christmas-club"] && !Shopify.designMode) return;
  try {
    
  const initializeChristmasClub = (root) => {
    if (root.dataset.tsccInitialized === 'true') return;

    const dialog = root.querySelector('[data-tscc-dialog]');
    const openButton = root.querySelector('[data-tscc-open]');
    const closeButton = root.querySelector('[data-tscc-close]');
    const variantField = root.querySelector('[data-tscc-variant-id]');

    if (!dialog || !openButton || !closeButton) return;

    const syncVariant = () => {
      if (!variantField) return;
      const productFormVariant = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (productFormVariant && productFormVariant.value) {
        variantField.value = productFormVariant.value;
      }
    };

    const openDrawer = () => {
      syncVariant();
      dialog.showModal();
      document.documentElement.classList.add('tscc-scroll-lock');
    };

    const closeDrawer = () => {
      dialog.close();
    };

    openButton.addEventListener('click', openDrawer);
    closeButton.addEventListener('click', closeDrawer);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDrawer();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('tscc-scroll-lock');
      openButton.focus();
    });

    root.dataset.tsccInitialized = 'true';

    const formResult = root.querySelector('[data-tscc-success], [data-tscc-errors]');
    if (formResult) {
      openDrawer();
      formResult.focus();
    }
  };

  const initializeAllChristmasClubs = () => {
    document.querySelectorAll('[data-tscc-root]').forEach(initializeChristmasClub);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllChristmasClubs, { once: true });
  } else {
    initializeAllChristmasClubs();
  }

  document.addEventListener('shopify:section:load', initializeAllChristmasClubs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trailsurge-product-features-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('feature-carousel')) {
    customElements.define('feature-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ts-track]');
        this.section = this.closest('.ts-features');
        this.previous = this.section.querySelector('[data-ts-previous]');
        this.next = this.section.querySelector('[data-ts-next]');
        if (!this.track || !this.previous || !this.next) return;
        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        new ResizeObserver(() => this.update()).observe(this.track);
        this.update();
      }

      move(direction) {
        const card = this.track.querySelector('.ts-features__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }

      update() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= maximum - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-product-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ts-product-comparison-v8')) {
  customElements.define('ts-product-comparison-v8', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected || this.abortController) return;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      const scroller = this.querySelector('.ts-cmp__wrap');
      if (!scroller) return;
      const toggle = this.querySelector('[data-toggle]');
      const extraRows = [...this.querySelectorAll('[data-extra-spec]')];
      if (toggle && extraRows.length) {
        const more = toggle.querySelector('[data-more]');
        const less = toggle.querySelector('[data-less]');
        const setExpanded = (expanded) => {
          extraRows.forEach(row => { row.hidden = !expanded; });
          toggle.setAttribute('aria-expanded', String(expanded));
          more.hidden = expanded;
          less.hidden = !expanded;
        };
        setExpanded(false);
        this.querySelector('[data-disclosure]').hidden = false;
        toggle.addEventListener('click', () => {
          const expanding = toggle.getAttribute('aria-expanded') !== 'true';
          const previousTop = toggle.getBoundingClientRect().top;
          setExpanded(expanding);
          if (!expanding) {
            const shift = toggle.getBoundingClientRect().top - previousTop;
            if (shift < 0) window.scrollBy({ top: shift, behavior: 'instant' });
          }
        }, options);
      }
      const navigation = this.querySelector('[data-navigation]');
      const previous = this.querySelector('[data-direction="-1"]');
      const next = this.querySelector('[data-direction="1"]');
      const updateNavigation = () => {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        const position = Math.abs(scroller.scrollLeft);
        navigation.hidden = maxScroll < 2;
        previous.disabled = position < 2;
        next.disabled = position >= maxScroll - 2;
      };
      [previous, next].forEach(button => {
        button.addEventListener('click', () => {
          const column = this.querySelector('.ts-cmp__product');
          const step = column ? column.getBoundingClientRect().width : scroller.clientWidth;
          const direction = getComputedStyle(scroller).direction === 'rtl' ? -1 : 1;
          scroller.scrollBy({
            left: Number(button.dataset.direction) * step * direction,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        }, options);
      });
      scroller.addEventListener('scroll', updateNavigation, { ...options, passive: true });
      window.addEventListener('resize', updateNavigation, options);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(updateNavigation);
        this.resizeObserver.observe(scroller);
      }
      updateNavigation();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.abortController?.abort();
      this.abortController = null;
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-showroom-video-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ts-showroom-viewing')) {
    const showroomRequests = new Map();
    function showroomProductIds(url) {
      if (!showroomRequests.has(url)) {
        const request = fetch(url, {
          credentials: 'same-origin',
          cache: 'no-store',
          signal: AbortSignal.timeout(10000)
        }).then(response => {
          if (!response.ok) throw new Error('Showroom unavailable');
          return response.text();
        }).then(html => {
          const page = new DOMParser().parseFromString(html, 'text/html');
          const items = page.querySelectorAll('[data-ts-showroom-stock] [data-ts-showroom-product]');
          return new Set(Array.from(items, item => item.getAttribute('data-ts-showroom-product')));
        }).catch(error => {
          showroomRequests.delete(url);
          throw error;
        });
        showroomRequests.set(url, request);
      }
      return showroomRequests.get(url);
    }
    customElements.define('ts-showroom-viewing', class extends HTMLElement {
      connectedCallback() {
        this.updateAvailability();
      }
      showEditorHelp() {
        if (!this.dataset.editor) return;
        const help = this.querySelector('[data-viewing-editor]');
        if (help) { help.hidden = false; this.hidden = false; }
      }
      async updateAvailability() {
        this.hidden = true;
        const panel = this.querySelector('[data-viewing-panel]');
        const help = this.querySelector('[data-viewing-editor]');
        if (panel) panel.hidden = true;
        if (help) help.hidden = true;
        if (!this.dataset.showroomUrl || !this.dataset.productId) {
          this.showEditorHelp();
          return;
        }
        try {
          const url = new URL(this.dataset.showroomUrl, window.location.origin);
          if (url.origin !== window.location.origin) return;
          const products = await showroomProductIds(url.href);
          if (!this.isConnected) return;
          if (products.has(this.dataset.productId)) {
            if (panel) panel.hidden = false;
            this.hidden = false;
          } else {
            this.showEditorHelp();
          }
        } catch (_) {
          if (this.isConnected) this.showEditorHelp();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
